import { useEffect } from "react";
import { ENVIRONMENT } from "../urls";

const cookieName =
  ENVIRONMENT === "PRODUCTION"
    ? "wp_geeksforgeeks"
    : "wd_geeksforgeeks";

const getCookie = (name) =>
  `; ${document.cookie}`.split(`; ${name}=`).pop().split(";")[0];

export default function RecommendedCourses({ data }) {
  useEffect(() => {
    if (data) {
      let recommendedCourses = getCookie(cookieName);
      recommendedCourses = recommendedCourses
        ? JSON.parse(recommendedCourses)
        : [];
      recommendedCourses = recommendedCourses?.courses || []
      let index =  recommendedCourses.findIndex(el => el.course_id === data.course_id)
      if(index === -1)
        recommendedCourses.unshift({...data,visit_count:1})
      else {
        let updatedElement = {...recommendedCourses[index]}
        recommendedCourses[index] = {...data,visit_count:updatedElement.visit_count + 1}
      }
      recommendedCourses = recommendedCourses.sort(function (a, b) {
        return new Date(b.last_visit_time) - new Date(a.last_visit_time);
      });
      recommendedCourses = recommendedCourses.slice(0,4)
      let recommendedCoursesData = { courses:recommendedCourses }
      document.cookie = `${cookieName}=${JSON.stringify(
        recommendedCoursesData
      )};domain=.geeksforgeeks.org;path=/;max-age=${31*24*60*60}`;
    }
  }, [data]);

  return null;
}
